import { DriveItem } from '@microsoft/microsoft-graph-types';
import { FC, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { useReplaceFile } from '../../services/graph/hooks/onedrive';
import { Button } from '../button/Button';
import { DropBox } from '../file/DropBox';
import { ModalWithHeader } from '../modal/ModalWithHeader';
import strings from './onedrive.translations';

interface Props {
  file: DriveItem;
  onUpdate: () => void;
}

export const DocumentUpdateButton: FC<Props> = ({ file, onUpdate }) => {
  const replaceFile = useReplaceFile();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [fileList, setFileList] = useState<FileList | undefined>();

  const onSubmit = async () => {
    const newFile = fileList?.item(0);
    if (!newFile) {
      return;
    }

    setLoading(true);

    try {
      await replaceFile(file.id!, file.name!, newFile);
      setModalOpen(false);
      onUpdate();
    } catch {
      setError(strings.delete.errors.unknown);
    }

    setLoading(false);
  };

  const changeNewFile = (list?: FileList) => {
    setError(undefined);

    const newVal = list?.item(0);
    if (newVal) {
      if (newVal.type !== file.file?.mimeType) {
        setError(strings.update.errors.incorrectFileType);
        return;
      }
      setFileList(list);
    }
  };

  const closeAndClear = () => {
    setModalOpen(false);
    setTimeout(() => {
      setFileList(undefined);
      setError(undefined);
    }, 500);
  };

  return (
    <>
      <button
        type="button"
        className="w-full bg-primary-std p-2 border-t flex items-center justify-center gap-2"
        onClick={() => setModalOpen(true)}
      >
        <FiUpload className="h-5 w-5" />
        <span>{strings.update.title}</span>
      </button>
      <ModalWithHeader open={modalOpen} onClose={closeAndClear} title={strings.update.title}>
        <div className="flex flex-col gap-5">
          <div>{strings.update.message(file.name!)}</div>
          <DropBox files={fileList} onChange={changeNewFile} onUpload={console.log} className="w-full h-40" />
          {error && <div className="text-red-500">{error}</div>}
          <div className="flex gap-2">
            <Button className="flex-1" onClick={closeAndClear}>
              {strings.common.cancel}
            </Button>
            <Button className="flex-1" primary onClick={onSubmit} loading={loading}>
              {strings.common.submit}
            </Button>
          </div>
        </div>
      </ModalWithHeader>
    </>
  );
};
